import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/villkor")({
  component: Terms,
  head: () => ({
    meta: [
      { title: "Användarvillkor – Alkoholprovet" },
      { name: "description", content: "Läs Alkoholprovets användarvillkor: konto, betalning, ångerrätt, ansvar och hur tjänsten för övning inför kunskapsprovet i alkohollagen fungerar." },
      { property: "og:title", content: "Användarvillkor – Alkoholprovet" },
      { property: "og:description", content: "Villkor för Alkoholprovet: konto, betalning, ångerrätt och ansvar för övningstjänsten inför kunskapsprovet i alkohollagen." },
      { property: "og:url", content: "https://alkoholprovet.se/villkor" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/villkor" }],
  }),
});

function Terms() {
  return (
    <article className="container-narrow py-14 prose-like">
      <h1 className="font-display text-4xl font-bold">Användarvillkor</h1>
      <p className="mt-2 text-sm text-muted-foreground">Senast uppdaterad: {new Date().getFullYear()}</p>

      <Section title="1. Om tjänsten">
        Alkoholprovet är ett fristående digitalt övningsverktyg som hjälper dig att förbereda dig inför kommunens kunskapsprov i alkohollagen. Tjänsten är inte kopplad till någon kommun eller myndighet.
      </Section>
      <Section title="2. Konto och åtkomst">
        Du behöver skapa ett konto för att använda fullständig funktionalitet. Du ansvarar för att uppgifterna du anger är korrekta och för att skydda dina inloggningsuppgifter.
      </Section>
      <Section title="3. Betalning och tillgång">
        Tillgång till premiumfunktioner köps som engångsbetalning för 7 eller 30 dagar. Betalning sker via Stripe. Tillgången upphör automatiskt efter perioden – inget abonnemang löper vidare.
      </Section>
      <Section title="4. Ångerrätt">
        Eftersom tjänsten är digital och tillgängliggörs omedelbart efter köp samtycker du i samband med köpet till att ångerrätten upphör när tillgång aktiverats.
      </Section>
      <Section title="5. Innehåll">
        Frågorna är pedagogiska träningsfrågor och inte kommunens sekretessbelagda provfrågor. Materialet uppdateras löpande men kan inte garanteras vara fullständigt eller juridiskt korrekt i varje detalj.
      </Section>
      <Section title="6. Ingen juridisk rådgivning">
        Innehållet i Alkoholprovet utgör inte juridisk rådgivning. För beslut i enskilda ärenden, kontakta din kommun eller juridisk expertis.
      </Section>
      <Section title="7. Ansvarsbegränsning">
        Alkoholprovet ansvarar inte för skada som uppstår till följd av att information i tjänsten används eller tolkas på visst sätt.
      </Section>
      <Section title="8. Ändringar">
        Vi kan komma att uppdatera dessa villkor. Du informeras om väsentliga ändringar via e-post eller i appen.
      </Section>
      <Section title="9. Kontakt">
        Frågor om villkoren kan ställas via vår kontaktsida.
      </Section>
    </article>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mt-8">
      <h2 className="font-display text-xl font-semibold">{title}</h2>
      <p className="mt-2 text-muted-foreground leading-relaxed">{children}</p>
    </section>
  );
}
